import type { FeatureConfigList } from '../../../services/features/types';
import { NetworkError } from '../../errors/NetworkError';
import { Fetcher } from '../../Fetcher';

export interface FetchFeatureFlagsParams {
  url: string;
  JSESSIONID: string;
}

const ENDPOINT = '/api/player/features/ui/configuredFeatures';

export const fetchFeatureFlags = ({ url, JSESSIONID }: FetchFeatureFlagsParams): Promise<FeatureConfigList> => {
  const combinedUrl = `${url}${ENDPOINT}`;
  return Fetcher.fetch<FeatureConfigList>(combinedUrl, {
    params: {
      JSESSIONID,
    },
  }).then<FeatureConfigList>((result) => {
    if (result.errorCode || result.error) {
      throw new NetworkError('Failed to fetch features', result, ENDPOINT, combinedUrl);
    }
    return result;
  });
};
